import type { StudySwimlaneSelectDto } from '@@types/api.types';
import { TooltipComponent } from '@components/core/tooltip.component';
import { BlueLabel } from '@components/shared/blue-label.component';
import { cn } from '@lib/utils';
import type { FC } from 'react';

type MeiaP3CoverageStripProps = {
  swimlanes: StudySwimlaneSelectDto[];
  taskCountBySwimlaneId: Map<string, number>;
};

const segmentClassForCount = (count: number): string => {
  if (count >= 2) return 'bg-emerald-500';
  if (count === 1) return 'bg-yellow-500';
  return 'bg-gray-300';
};

export const MeiaP3CoverageStrip: FC<MeiaP3CoverageStripProps> = (props) => {
  const { swimlanes, taskCountBySwimlaneId } = props;
  if (swimlanes.length === 0) return null;

  const coveredCount = swimlanes.filter((swimlane) => (taskCountBySwimlaneId.get(swimlane.id) ?? 0) > 0).length;

  return (
    <div className="flex flex-col gap-2 rounded-md border border-gray-200 bg-white p-3">
      <div className="flex items-center justify-between gap-2">
        <BlueLabel
          className="text-xs"
          text="G3 Coverage"
        />
        <span className="text-xs text-gray-500">
          {coveredCount}/{swimlanes.length} stages covered
        </span>
      </div>
      <div className="flex items-center gap-1">
        {swimlanes.map((swimlane) => {
          const taskCount = taskCountBySwimlaneId.get(swimlane.id) ?? 0;

          return (
            <TooltipComponent
              key={swimlane.id}
              side="top"
              trigger={<span className={cn('h-2 flex-1 rounded-full', segmentClassForCount(taskCount))} />}
            >
              {swimlane.phaseName} · {taskCount} {taskCount === 1 ? 'task' : 'tasks'}
            </TooltipComponent>
          );
        })}
      </div>
    </div>
  );
};
